export function updateLoadableInState(setState, key, patch) {
    setState((oldState) => ({
        ...oldState,
        [key]: {
            ...oldState[key],
            ...patch,
        },
    }));
}
//# sourceMappingURL=helpers.js.map